import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const btn = theme => css`
  border-radius: ${rem(200)};
  width: 100%;
  font-weight: ${theme.fontWeight.normal};
  font-family: ${theme.font.secondary};
`

export const styles = {
  btn,
}
